import { z } from 'zod';

/**
 * 계정 닉네임 (account-nickname-photo 설계). trim·NFC 정규화 후 한글 완성형·영문·숫자 2~16자.
 * 자모 단독(ㅅㅂ)·공백·이모지·제로폭 문자는 정규식에서 걸러진다. 서버 라우트와 클라 폼이 함께 쓴다.
 */
export const Nickname = z
  .string()
  .transform((s) => s.trim().normalize('NFC'))
  .pipe(z.string().regex(/^[가-힣a-zA-Z0-9]{2,16}$/));
